export const CONTACT_TYPE = {
  mobile: 'MOBILE',
  work: 'WORK',
  home: 'HOME',
};

export const CONTACT_TYPE_LIST = Object.values(CONTACT_TYPE);
